import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { JobService } from 'src/app/services/jobs/job.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';

@Component({
  selector: 'app-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],


})
export class CardViewComponent implements OnInit {

  @Input('job') job;
  @Input('index') index;
  @Output() jobDeleted: EventEmitter<any> = new EventEmitter<any>();
  loading: boolean = true;
  constructor(private router: Router, public _jobService: JobService, public _snackBar: MatSnackBar, public dialog: MatDialog) { }

  ngOnInit() {
  }

  editJobModal(data) {
    console.log('data while edit', data);
    this.router.navigateByUrl('/edit-job/' + data._id, { state: { job: data, view: 'isCard' } });
  }

  delete(id) {
    this.openDialog(DeleteConfirmModalComponent, "Job").subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._jobService.deleteJobs(id).subscribe(data => {
          this.loading = false;
          this.jobDeleted.emit({ index: this.index })
        }, err => {
          this.handleSnackBar({ msg: "Something Went Wrong!", button: "Ok" });
          this.loading = false;
        });
      }

    })
  }
  navigate() {
    this.router.navigateByUrl('/jobs/' + this.job._id);
  }

  // Utility functions

  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

}
